import React from "react";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import FormField from "./FormField";
import { useSelector } from "react-redux";
import { Loader2 } from "lucide-react";

const PartInfoFields = ({
  formData,
  handleSelectChange,
  handleInputChange,
  errors,
  availableParts,
  isSubmitting
}) => {
  const { categories, partNamesLoading } = useSelector((state) => state.parts);
  const isOtherCategory =
    formData.partCategory?.toLowerCase() === "others" ||
    formData.partCategory?.toLowerCase() === "other";
  const isOtherPartName = formData.partName?.toLowerCase() === "other";

  return (
    <>
      <FormField
        id="partCategory"
        label="Part Category"
        error={errors.partCategory || errors.partCategoryOther}
      >
        <Select
          onValueChange={(val) => handleSelectChange("partCategory", val)}
          value={formData.partCategory}
          name="partCategory"
          disabled={isSubmitting}
        >
          <SelectTrigger id="partCategory">
            <SelectValue placeholder="Select Part Category" />
          </SelectTrigger>
          <SelectContent>
            {categories?.map((category) => (
              <SelectItem key={category.id} value={category.name}>
                {category.name.toLowerCase() === "other"
                  ? "Other (Specify Below)"
                  : category.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        {isOtherCategory && (
          <Input
            id="partCategoryOther"
            name="partCategoryOther"
            placeholder="Specify Category"
            value={formData.partCategoryOther}
            onChange={handleInputChange}
            className="mt-2"
            disabled={isSubmitting}
          />
        )}
      </FormField>

      <div className="md:col-span-2">
        <FormField
          id="partName"
          label="Part Name / Title"
          error={errors.partName || errors.partNameOther}
        >
          <Select
            onValueChange={(val) => handleSelectChange("partName", val)}
            value={formData.partName}
            name="partName"
            disabled={
              !formData.partCategory || isSubmitting || partNamesLoading
            }
          >
            <SelectTrigger id="partName">
              {partNamesLoading ? (
                <div className="flex items-center">
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Loading part names...
                </div>
              ) : (
                <SelectValue
                  placeholder={
                    formData.partCategory
                      ? "Select Part Name"
                      : "Select Category First"
                  }
                />
              )}
            </SelectTrigger>
            <SelectContent>
              {availableParts?.map((part) => (
                <SelectItem key={part.id} value={part.name}>
                  {part.name}
                </SelectItem>
              ))}
              <SelectItem value="Other">Other (Specify Below)</SelectItem>
            </SelectContent>
          </Select>

          {isOtherPartName && (
            <Input
              id="partNameOther"
              name="partNameOther"
              placeholder="Specify Part Name"
              value={formData.partNameOther}
              onChange={handleInputChange}
              className="mt-2"
              disabled={isSubmitting}
            />
          )}
        </FormField>
      </div>

      <div className="md:col-span-2">
        <FormField
          id="detailedDescription"
          label="Detailed Description / Condition"
          required={false}
        >
          <Textarea
            id="detailedDescription"
            name="detailedDescription"
            placeholder="Details about condition, compatibility, etc. (Optional)"
            value={formData.detailedDescription}
            onChange={handleInputChange}
            rows={4}
            disabled={isSubmitting}
          />
        </FormField>
      </div>
    </>
  );
};

export default PartInfoFields;
